export const LIVE_CHAT_FORM_URL = (transactionId: number) =>
  `/help/for_transaction/${transactionId}/live_chat`
export const TRENDSALES_PAYOUT_FORM_URL = '/help/trendsales_payout'
export const APP_FEEDBACKS_URL = '/app_feedbacks'
export const HC_ROOT_PATH = '/help'
export const NEW_COMPLAINTS_URL = '/complaints/new'
export const COMPLAINT_CREATION_URL = '/complaints/report'

// Note: These routes are also duplicated in other slices outside of help-center
export const NEW_HELP_TICKET_URL = '/help/support_tickets/new'
export const HELP_SEARCH_URL = '/help/s'
